(function () {
  angular.module("akitabox.asset").run(states);

  /* @ngInject */
  function states(models, Router) {
    Router.configureStates([
      {
        state: "app.building.asset",
        config: {
          abstract: true,
          url: "/" + models.ASSET.ROUTE_PLURAL + "/:assetId",
          template: '<div flex layout="column" layout-fill ui-view></div>',
          resolve: {
            asset: getAsset,
          },
        },
      },
      {
        state: "app.building.assets",
        config: {
          url: "/" + models.ASSET.ROUTE_PLURAL + "?q",
          templateUrl: "app/mobile/modules/asset/list/list.html",
          controller: "AssetListController",
          controllerAs: "vm",
          reloadOnSearch: false,
          resolve: {
            query: getQuery,
          },
          data: {
            pageTitle: "Assets",
          },
        },
      },
    ]);
  }

  // ------------------------
  //   Detail
  // ------------------------

  /** @ngInject */
  function getAsset(
    /* Angular */
    $q,
    /* Third-party */
    $stateParams,
    /* Akitabox */
    account,
    models,
    /* Constants */
    NOT_ALLOWED_VIEW_DETAIL_PREFIX,
    /* Resolve */
    building,
    /* Services */
    AssetService
  ) {
    // If allowed, fetch the asset
    var params = {
      include_values: true,
    };
    var options = {
      includePinType: true,
    };
    return AssetService.getById(
      building._id,
      $stateParams.assetId,
      params,
      options
    );
  }

  // ------------------------
  //   List
  // ------------------------

  /** @ngInject */
  function getQuery(account, $stateParams) {
    return $stateParams.q;
  }
})();
